import Vue from 'vue'

export default new Vue ({
    name: 'common',
    methods: {
        createSuccessMessage(message, duration) {
            const toastDuration = duration ? duration : 2000
            this.$buefy.toast.open({
                duration: toastDuration,
                message: message,
                type: 'is-success'
            })
        },
        createErrorMessage(e, message) {
            if( e ){
                this.$buefy.toast.open({
                    duration: 2000,
                    message: message,
                    type: 'is-danger'
                })
            }else{
                this.$buefy.toast.open({
                    duration: 2000,
                    message: 'サーバーエラーです。しばらく経ってからもう一度お試しください。',
                    type: 'is-danger'
                })
            }
        }
    }
})